import { titleCase } from 'title-case';

export const enumToTitle = (value: string) => titleCase(value.replace(/_/g, ' ').toLowerCase());
